// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chart-bar[data-v-59613512]{-o-object-fit:contain;object-fit:contain;width:100%;min-height:450px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
